// src/pages/DashboardPage.js
import React, { useEffect, useState } from "react";
import { getMyGpts } from "../services/api";
import { Link } from "react-router-dom";
import styles from "../css/shared.module.css";
import { FiMessageSquare } from "react-icons/fi";

const DashboardPage = () => {
  // La lógica de estado se mantiene igual
  const [gpts, setGpts] = useState([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // La lógica de fetching se mantiene igual
  useEffect(() => {
    const fetchGpts = async () => {
      setIsLoading(true); // Siempre inicia la carga
      try {
        const res = await getMyGpts();
        if (res.success) {
          setGpts(res.data);
        } else {
          setError(res.message || "No se pudieron cargar los GPTs.");
        }
      } catch (err) {
        setError("Ocurrió un error de red.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchGpts();
  }, []);

  // ✅ LA SOLUCIÓN: Movemos la lógica condicional fuera del JSX para más claridad.
  // Creamos una variable para guardar el contenido del cuerpo de la tabla.
  let tableBodyContent;

  if (isLoading) {
    tableBodyContent = (
      <tr>
        <td colSpan="3">Cargando tus GPTs...</td>
      </tr>
    );
  } else if (error) {
    tableBodyContent = (
      <tr>
        <td colSpan="3" style={{ color: "var(--danger-color)" }}>
          {error}
        </td>
      </tr>
    );
  } else if (gpts.length === 0) {
    tableBodyContent = (
      <tr>
        <td colSpan="3">Actualmente no tienes ningún GPT asignado.</td>
      </tr>
    );
  } else {
    tableBodyContent = gpts.map((gpt) => (
      <tr key={gpt._id}>
        <td>
          <span style={{ fontWeight: "500" }}>{gpt.name}</span>
        </td>
        <td style={{ color: "var(--text-light)" }}>{gpt.description}</td>
        <td>
          <Link to={`/gpt/${gpt._id}`} className={styles.button}>
            <FiMessageSquare size={16} />
            <span>Abrir Chat</span>
          </Link>
        </td>
      </tr>
    ));
  }

  return (
    <div>
      <h1 className={styles.title}>
        <span role="img" aria-label="cerebro">
          🧠
        </span>
           Mis MentorIAs
      </h1>
      <p className={styles.subtitle}>
        Aquí encontrarás todos los asistentes de IA que tienes asignados.
      </p>

      <div className={styles.card}>
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Nombre del GPT</th>
                <th>Descripción</th>
                <th style={{ width: "150px" }}>Acción</th>
              </tr>
            </thead>
            {/* ✅ Ahora, el tbody solo contiene la variable, que siempre será
                o un <tr> o un array de <tr>. ¡A prueba de errores! */}
            <tbody>{tableBodyContent}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
